module.exports = __webpack_public_path__ + "static/media/fj.60620e85.svg";